export const SET_IMAGE_URL_REQUEST = "SET_IMAGE_URL_REQUEST";
export const SET_IMAGE_URL_SUCCESS = "SET_IMAGE_URL_SUCCESS";
export const SET_IMAGE_URL_FAIL = "SET_IMAGE_URL_FAIL";
